import { inject, Injectable } from '@angular/core';
import {
  HttpRequest,
  HttpHandler,
  HttpEvent,
  HttpInterceptor,
  HttpResponse,
  HttpErrorResponse,
  HttpHandlerFn
} from '@angular/common/http';

import { BehaviorSubject, Observable, throwError } from 'rxjs';
import { catchError, filter, map, switchMap, take } from 'rxjs/operators';
import { Router } from '@angular/router';
import { AuthService } from '../services/auth.service';

let isRefreshing = false;
const refreshTokenSubject: BehaviorSubject<string | null> = new BehaviorSubject<string | null>(null);

@Injectable()
export class AuthTokenInterceptor implements HttpInterceptor {

  private auth = inject(AuthService);
  private router = inject(Router);

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {

    if (request.url.includes('/api-idba/v4/public/config')) {
      return next.handle(request);
    }

    const token = this.auth.getTokenBackEnd();

    const headers: Record<string, string> = {
      urlOrigin: this.router.url.split(/[?#]/, 1)[0]
    };

    if (token) {
      headers['Authorization'] = `${token}`;
    }

    const authRequest = request.clone({
      setHeaders: headers
    })

    return next.handle(authRequest).pipe(
      catchError((error) => {
        if (error instanceof HttpErrorResponse && error.status === 401 && !request.url.includes('/auth')) {
          return handle401Error(authRequest, next.handle, this.auth);
        }

        return throwError(() => error);
      })
    );

  }
}

function handle401Error(request: HttpRequest<any>, next: HttpHandlerFn, authService: AuthService): Observable<HttpEvent<any>> {

  if (!isRefreshing) {
    isRefreshing = true;
    refreshTokenSubject.next(null);

    return authService.refreshToken().pipe(
      catchError((err) => {
        isRefreshing = false;
        authService.logout();
        return throwError(() => err);
      }),
      switchMap((response: any) => {
        isRefreshing = false;
        const newToken = response.body.token;
        refreshTokenSubject.next(newToken);
        return next(request.clone({ setHeaders: { Authorization: `${newToken}` } }));
      })
    );
  }
  else {
    return refreshTokenSubject.pipe(
      filter(token => token !== null),
      take(1),
      switchMap((newToken) => {
        return next(
          request.clone({
            setHeaders: {
              Authorization: `${newToken}`
            }
          })
        );
      })
    );
  }
}
